<template lang="html">
  <div :class="completeClassName" :data-format="options.format">
    <label :for="_uid">{{ label }}</label>
    <input :id='_uid' :value='value' type='text' ref='input'/>
    <a class="kd-form__datepicker_btn" href="javascript:;" @click='onBtnClick'>
      <i class="kf-calendar datepickerbutton"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      default: 'Date'
    },
    value: {
      default: ''
    },
    className: {
      default: ''
    },
    options: {
      default() {
        return {
          format: 'MM/DD/YYYY hh:mm A z'
        };
      }
    }
  },
  computed: {
    completeClassName() {
      return `datepicker datetimepicker date ${this.className}`
    }
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.value)
    },
    onBtnClick() {
      this.$refs.input.focus()
    }
  },
  mounted() {
    this.$nextTick(() => {
      $(`#${this._uid}`).datetimepicker()
      // vue doesn't like to listen to the jquery update events so setting
      // listeners here
      $(`#${this._uid}`).change(this.onChange)
    })
  },
}
</script>
